import { Link } from 'react-router-dom';
import { realCases } from '../../data/content';
import './RealCases.css';

function RealCases() {
  return (
    <section id="casos" className="section real-cases">
      <div className="container">
        <div className="section-header">
          <h2>Casos reais</h2>
          <p>Veja como transformamos processos em cada área da empresa.</p>
        </div>

        <div className="cases-grid">
          {realCases.map((item) => (
            <Link key={item.slug} to={`/casos/${item.slug}`} className="case-link-card">
              <span className="case-area">{item.area}</span>
              <p>{item.summary}</p>
              <span className="case-cta">Ver caso completo →</span>
            </Link>
          ))}
        </div>

        <div className="cases-more">
          <Link to="/casos" className="btn btn-outline">Ver todos os casos de uso</Link>
        </div>
      </div>
    </section>
  );
}

export default RealCases;
